import type { DayOfWeek, MealType } from '../types';

export function mealBelongsToSlot(meal: { mealType?: MealType }, mealType: MealType): boolean {
    return meal.mealType === mealType || (mealType === 'Dinner' && !meal.mealType);
}

export function buildCookingSessionDocId(
    weekOffset: number,
    day: DayOfWeek,
    mealType: MealType
): string {
    return `${weekOffset}_${day}_${mealType}`;
}

export function parseCookingSessionDocId(docId: string): {
    weekOffset: number;
    day: DayOfWeek;
    mealType: MealType;
} | null {
    const match = /^(-?\d+)_(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)_(Breakfast|Lunch|Dinner)$/.exec(docId);
    if (!match) return null;
    return {
        weekOffset: Number(match[1]),
        day: match[2] as DayOfWeek,
        mealType: match[3] as MealType,
    };
}
